import { apiClient } from './api'

export interface TransferEligibility {
  eligible: boolean
  reason?: string
}

export interface TransferResult {
  transferId: string
  targetEmail: string
  transferredAt: string
}

interface ApiEnvelope<T> {
  success: boolean
  data: T
  error?: { code: string; message: string }
}

export const transferService = {
  /** Check whether an enrollment is transferable right now. */
  checkEligibility: async (enrollmentId: string): Promise<TransferEligibility> => {
    const resp = await apiClient.get<ApiEnvelope<Record<string, unknown>>>(
      `/me/enrollments/${enrollmentId}/transfer-eligibility`,
    )
    if (!resp.data?.success) {
      throw new Error(resp.data?.error?.message || 'Failed to check eligibility')
    }
    return {
      eligible: (resp.data.data.eligible as boolean) === true,
      reason: resp.data.data.reason as string | undefined,
    }
  },

  /** Transfer a ticket to another email. */
  transfer: async (
    enrollmentId: string,
    body: { targetEmail: string; targetName?: string; reason?: string },
  ): Promise<TransferResult> => {
    const resp = await apiClient.post<ApiEnvelope<Record<string, unknown>>>(
      `/me/enrollments/${enrollmentId}/transfer`,
      {
        target_email: body.targetEmail,
        target_name: body.targetName,
        reason: body.reason,
      },
    )
    if (!resp.data?.success) {
      throw new Error(resp.data?.error?.message || 'Failed to transfer')
    }
    const raw = resp.data.data
    return {
      transferId: raw.transfer_id as string,
      targetEmail: raw.target_email as string,
      transferredAt: raw.transferred_at as string,
    }
  },
}

export default transferService
